/* eslint-disable */

import React, { useState } from "react";
import ArticleBase from "./article-base.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo.js";
import Currency from "../../../ui-components/currency/currency.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import RaindropSlider from "../../../ui-components/raindrop-slider/raindrop-slider.tsx";
import OrganisationTitle from "../../../ui-components/organisation-title/organisation-title.tsx";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import {
  EXAMPLE_ACCOUNT_USER_URL,
  EXAMPLE_ORGANISATION_ALPHA_NAME,
  EXAMPLE_ORGANISATION_ALPHA_URL,
  EXAMPLE_ORGANISATION_BETA_NAME,
  EXAMPLE_ORGANISATION_BETA_URL,
  URL_RAINDROP,
} from "../../../services/constants.js";
import { Size } from "../../../logic/enums.ts";
import { ShnoodleImageType } from "../../../ui-components/shnoodle-image/shnoodle-image.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import OrganisationSupportElement from "../../../ui-components/organisation-support-element/organisation-support-element.js";
import WaterfallIcon from "../../../ui-components/waterfall-icon/waterfall-icon.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";

const ArticleSubtitle = ({ text }) => {
  return <h2 className="text-3xl font-black pt-10">{text}</h2>;
};

const ContentSimplicity = () => {
  const initialValue = 60;
  const [value, setValue] = useState(initialValue);

  const values = [
    {
      organisationId: "sausage_5FE115AC-D833-49CA-94FF-3D0FB98A7FFD",
      value: 100 - value,
      oldValue: 100 - value,
      selected: false,
    },
    {
      organisationId: "sausage_B87510D1-4E07-4062-A73D-F1C32833AA5D",
      value: value,
      oldValue: value,
      selected: true,
    },
  ];

  return (
    <div className="flex flex-col md:flex-row items-center gap-12 w-full max-w-4xl items-center justify-center">
      <div className="flex flex-col w-full max-w-md p-2 items-center gap-4 ">
        <RaindropCircle
          sausageValues={values}
          isSpringyTransition={false}
          isUsingLayout={false}
          size="SMALL"
        />

        <div className="flex flex-col gap-2 w-full">
          <div className="flex flex-row gap-2  items-center ">
            <OrganisationLogo src={EXAMPLE_ORGANISATION_ALPHA_URL} />

            <OrganisationTitle
              title={EXAMPLE_ORGANISATION_ALPHA_NAME}
              isHydrated={true}
            />

            <div className="ml-auto font-bold text-lg text-color-raindrop-primary text-opacity-60">
              <Currency
                currency={"GBP"}
                subunits={1000 * (values[0].value / 100)}
                isStylised={true}
              />
            </div>
          </div>

          <div className="flex flex-row gap-2 items-center  ">
            <OrganisationLogo src={EXAMPLE_ORGANISATION_BETA_URL} />

            <OrganisationTitle
              title={EXAMPLE_ORGANISATION_BETA_NAME}
              isHydrated={true}
            />
            <div className="ml-auto font-bold text-lg text-color-raindrop-primary ">
              <Currency
                currency={"GBP"}
                subunits={1000 * (values[1].value / 100)}
                isStylised={true}
              />
            </div>
          </div>

          <RaindropDivider />

          <div className="flex flex-row gap-2  items-center ">
            <div className="font-bold whitespace-nowrap">Your contribution</div>
            <div className="ml-auto font-bold text-lg w-fit">
              <Currency currency={"GBP"} subunits={1000} isStylised={true} />
            </div>
          </div>
        </div>
        <div className="w-full">
          <RaindropSlider
            min={10}
            max={90}
            value={value}
            onChange={(newValue) => setValue(newValue)}
          />
        </div>
      </div>
    </div>
  );
};

const Article003 = () => {
  const [isSupportingWaterfall, setIsSupportingWaterfall] = useState(false);

  const sausageValues = !isSupportingWaterfall
    ? [
        {
          id: "first",
          value: 20,
          selected: false,
        },
        {
          id: "second",
          value: 80,
          selected: false,
        },
      ]
    : [
        {
          id: "first",
          value: 15,
          selected: false,
        },
        {
          id: "second",
          value: 75,
          selected: false,
        },
        {
          id: "third",
          value: 10,
          selected: false,
        },
      ];

  return (
    <ArticleBase
      title={"What is a Raindrop Waterfall?"}
      shnoodleType={ShnoodleImageType.Waterfall}
    >
      <div className="flex flex-col w-full justify-center gap-12 text-left">
        <RaindropTextParagraph>
          Shnoodle, you ask the best questions. The Raindrop Waterfall concept
          can be confusing, so let's jump right in.
        </RaindropTextParagraph>

        <ArticleSubtitle text={"What is a waterfall?"} />
        <RaindropTextParagraph>
          A Raindrop Waterfall is a simple way for someone to directly raise
          money for things they care about.
        </RaindropTextParagraph>
        <RaindropTextParagraph>
          Before we fully understand what it is, let's add one to our Raindrop
          Circle. Our friend Nick has created a waterfall and wants you to
          support him, go ahead and do that now.
        </RaindropTextParagraph>

        <div className="flex flex-col w-full items-center">
          <div className="flex flex-col gap-2 items-center w-full max-w-md">
            <RaindropCircle size="SMALL" sausageValues={sausageValues} />
            <RaindropCard>
              <div className="flex flex-col gap-2 w-full">
                <div className="flex flex-row gap-2 items-center">
                  <OrganisationLogo src={EXAMPLE_ORGANISATION_BETA_URL} />
                  <RaindropTextHeading1>
                    {EXAMPLE_ORGANISATION_BETA_NAME}
                  </RaindropTextHeading1>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <OrganisationLogo src={EXAMPLE_ORGANISATION_ALPHA_URL} />
                  <RaindropTextHeading1>
                    {EXAMPLE_ORGANISATION_ALPHA_NAME}
                  </RaindropTextHeading1>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <WaterfallIcon
                    urlUser={EXAMPLE_ACCOUNT_USER_URL}
                    urlOrganisation={EXAMPLE_ORGANISATION_BETA_URL}
                  />
                  <RaindropTextHeading1>
                    Nick's Runs for Good
                  </RaindropTextHeading1>
                  <Spacer />
                  <RaindropButton
                    title="Give"
                    icon={isSupportingWaterfall ? "fa-solid fa-check" : null}
                    isHidingTitle={isSupportingWaterfall}
                    onClick={() =>
                      setIsSupportingWaterfall(!isSupportingWaterfall)
                    }
                  />
                </div>
              </div>
            </RaindropCard>
          </div>
        </div>

        <RaindropTextParagraph>
          Great! You've added Nick's Raindrop Waterfall to your Raindrop Circle.
        </RaindropTextParagraph>

        <ArticleSubtitle text={"... but what is it?"} />
        <RaindropTextParagraph>
          Our friend Nick cares deeply about the work{" "}
          {EXAMPLE_ORGANISATION_BETA_NAME} are doing. So he has committed to
          running 10 km every weekend to try raise money for them.
        </RaindropTextParagraph>
        <RaindropTextParagraph>
          You Shnoodle, as Nick's friend, are now giving a part of your
          contribution to support him.
        </RaindropTextParagraph>
        <RaindropTextParagraph>
          The money will flow through Nick's Waterfall directly to the
          organisation he has chosen to support.
        </RaindropTextParagraph>
        <RaindropTextParagraph>Pretty neat 🥳</RaindropTextParagraph>
        <RaindropTextParagraph>
          <div className="italic">
            Note • In our circle above, some of our contribution is going
            directly to {EXAMPLE_ORGANISATION_BETA_NAME}, while another segment
            is also going to {EXAMPLE_ORGANISATION_BETA_NAME} but through Nick's
            Waterfall.
          </div>
        </RaindropTextParagraph>

        <ArticleSubtitle text={"Can I see how he's doing?"} />
        <RaindropTextParagraph>Yes!</RaindropTextParagraph>
        <RaindropTextParagraph>
          Nick can post updates on his waterfall so you can follow his progress
          and keep him motivated. These will appear on your Home Page after you
          start supporting him.
        </RaindropTextParagraph>

        <ArticleSubtitle text={"How do I make one?"} />
        <RaindropTextParagraph>
          Creating your own waterfall is easy. Simply use the Waterfall tab,
          choose your organisation and get going.
        </RaindropTextParagraph>
        <RaindropTextParagraph>
          You can also{" "}
          <span className="font-black text-color-raindrop-primary">
            Cascade a waterfall
          </span>{" "}
          if you like an idea and want to do it yourself. But more on that
          another time 🤫
        </RaindropTextParagraph>
        <RaindropTextParagraph>
          ... and that's it Shnoodle!
        </RaindropTextParagraph>

        <RaindropTextParagraph>See you next time 💕</RaindropTextParagraph>
      </div>
    </ArticleBase>
  );
};

export default Article003;
